import { Link } from "wouter";
import { Calendar, Mail } from "lucide-react";

export default function BirthdayFooter() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t bg-muted/50">
      <div className="container px-4 md:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand Section */}
          <div className="space-y-3">
            <div className="flex items-center space-x-2">
              <div className="w-8 h-8 bg-gradient-to-br from-pink-500 to-purple-600 rounded-xl flex items-center justify-center">
                <Calendar className="w-5 h-5 text-white" />
              </div>
              <span className="font-bold">Birthday Reminder</span>
            </div>
            <p className="text-sm text-muted-foreground">
              Never forget a birthday again. Track friends & family with complete privacy.
            </p>
          </div>

          {/* Product Links */}
          <div>
            <h3 className="font-semibold mb-3">Product</h3>
            <ul className="space-y-2">
              <li>
                <Link href="/birthdayreminder">
                  <a className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                    Features
                  </a>
                </Link>
              </li>
              <li>
                <Link href="/birthdayreminder">
                  <a className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                    Download
                  </a>
                </Link>
              </li>
            </ul>
          </div>

          {/* Support Links */}
          <div>
            <h3 className="font-semibold mb-3">Support</h3>
            <ul className="space-y-2">
              <li>
                <Link href="/birthdayreminder/support">
                  <a className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                    Help Center
                  </a>
                </Link>
              </li>
              <li>
                <Link href="/birthdayreminder/privacy">
                  <a className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                    Privacy Policy
                  </a>
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-semibold mb-3">Contact</h3>
            <ul className="space-y-2">
              <li>
                <a
                  href="mailto:developer@designr.co"
                  className="text-sm text-muted-foreground hover:text-foreground transition-colors flex items-center space-x-2"
                >
                  <Mail className="w-4 h-4" />
                  <span>developer@designr.co</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-2 md:space-y-0">
            <p className="text-sm text-muted-foreground">
              © {currentYear} Designr. All rights reserved.
            </p>
            <p className="text-sm text-muted-foreground">
              Made with ❤️ for people who care about relationships
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}

